// services/apiservice.js
const API_BASE = "https://api.bootcamp.securxperts.com:8000";

const getAuthToken = () => localStorage.getItem("token");

const apiFetch = async (url, options = {}) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
    ...options,
  };

  if (getAuthToken()) {
    config.headers.Authorization = `Bearer ${getAuthToken()}`;
  }

  const response = await fetch(url, config);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const loginUser = async (email, password) => {
  const response = await apiFetch(`${API_BASE}/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  // Debug: Log the full response to console
  console.log("API Login Response:", response);

  // Try common token field variations; adjust based on logged output
  const token = response.token || response.access_token || response.data?.token || response.auth?.token;
  if (token) {
    localStorage.setItem("token", token);
  } else {
    throw new Error("Login failed: No token received. Check console for response details.");
  }
  return response;
};

export const getRegistrations = async (limit = 200, offset = 0) => {
  const params = new URLSearchParams({ limit: limit.toString(), offset: offset.toString() });
  return apiFetch(`${API_BASE}/admin/registrations?${params}`);
};

export const downloadExcel = async (limit = 200, offset = 0) => {
  const data = await getRegistrations(limit, offset);
  const XLSX = await import("xlsx");

  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Registrations");
  XLSX.writeFile(wb, `registrations_${new Date().toISOString().split('T')[0]}.xlsx`);
};